import {
  showNotification,
  decreaseScreenShare
} from '@shoflo/studio-redux/actions';
import { deleteSource } from 'actions/source';
import { SCREEN_PRESENTER } from '@shoflo/polymer';

/**
 * This will be called whenever share screen request
 * is approved by host then speaker cancels.
 * @param {Object} param0
 * @param {String} attendeeId
 */
function cancelAttendeeScreen({ dispatch, getState }, attendeeId) {
  dispatch(decreaseScreenShare());
  const message = 'Screen share was cancelled by presenter.';
  dispatch(
    showNotification(message, {
      timeout: 5500,
      type: 'alert'
    })
  );

  const {
    broadcastSources: { sources }
  } = getState();
  const sourceValue = `${attendeeId}#content`;

  const source = sources
    .filter(({ type }) => type === SCREEN_PRESENTER)
    .find(({ value }) => value === sourceValue);

  if (source) {
    dispatch(deleteSource(source._id));
  }
}

export default cancelAttendeeScreen;
